// extracted by mini-css-extract-plugin
export var container = "image-module--container--2b65e";
export var credits = "image-module--credits--d1dd5";
export var long = "image-module--long--ec600";
export var short = "image-module--short--ee4eb";
export var sideCredits = "image-module--sideCredits--74f56";
export var topCredit = "image-module--topCredit--f3846";